import PublicLayout from "@/views/public/Layout";
import Login from "@/views/public/Login";
import Confirm from "@/views/public/Confirm";
import SetPassword from "@/views/public/SetPassword";
import ResetPassword from "@/views/public/ResetPassword";
import SendTAC from "@/views/public/SendTAC";

const routes = [
  {
    path: "/",
    name: "PublicLayout",
    component: PublicLayout,
    children: [
      {
        path: "login",
        name: "Login",
        component: Login,
        meta: {
          title: "login",
          anonymousAccess: true
        }
      },
      {
        path: "static",
        name: "StaticLogin",
        component: Login,
        meta: {
          title: "login",
          anonymousAccess: true
        }
      },
      {
        path: "/send-tac",
        name: "SendTAC",
        component: SendTAC,
        meta: {
          title: "sendTAC",
          anonymousAccess: true
        }
      },
      {
        path: "/reset-password/:username?",
        name: "ResetPassword",
        component: ResetPassword,
        meta: {
          title: "setNewPassword",
          anonymousAccess: true
        }
      },
      {
        path: "/confirm",
        name: "Confirm",
        component: Confirm,
        meta: {
          title: "تائید کد موقت",
          anonymousAccess: true
        }
      },
      {
        path: "/set-password",
        name: "SetPassword",
        component: SetPassword,
        meta: {
          title: "تعیین رمز ورود",
          anonymousAccess: true
        }
      }
    ]
  }
];

export default routes;
